import { render, staticRenderFns } from "./MyVaccinePass.vue?vue&type=template&id=919f9f7e&scoped=true&"
import script from "./MyVaccinePass.vue?vue&type=script&lang=js&"
export * from "./MyVaccinePass.vue?vue&type=script&lang=js&"
import style0 from "./MyVaccinePass.vue?vue&type=style&index=0&id=919f9f7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "919f9f7e",
  null
  
)

export default component.exports